module.exports = __webpack_public_path__ + "img/project-6.90e21248.png";